<template>
  <b-container>
    <b-row style="margin-top: 5em">
      <b-col>
        <h2 class="text-info">
          {{ $t("globals.customers_merge") }}:
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span class="m-1">Select main customer (The one that will keep existing):</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="max-width: 500px">
        <ulu-multiselect
          class="m-1"
          v-model="masterCustomer"
          :options="customers"
          label="label"
          track-by="label"
          :placeholder="$t('globals.select_customer')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span class="m-1">Select the duplicate customer (The one that will be deleted)</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="max-width: 500px">
        <ulu-multiselect
          class="m-1"
          v-model="slaveCustomer"
          :options="customers"
          label="label"
          track-by="label"
          :placeholder="$t('globals.select_customer')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn
          variant="success"
          class="m-1 mt-3"
          @click="submit"
          :disabled="!(masterCustomer && slaveCustomer)"
        >
          {{ $t('globals.merge') }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span class="m-1 text-danger">{{ msg }}</span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    "ulu-multiselect": () => import("vue-multiselect")
  },
  data() {
    return {
      customers: [],
      masterCustomer: null,
      slaveCustomer: null,
      msg: ""
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    fetchCustomers() {
      const data = {
        query: `
          query { 
            CustomersAll (type: "company") {
              id
              company_name
            }
          }
        `
      };

      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.customers = res.CustomersAll.map((cst)=> {
            return {
              id: cst.id,
              name: cst.company_name,
              label: `(${cst.id}) ${cst.company_name}` 
            }
          })
        }
      }).finally(()=>{
        //this.searching_imei = false;
      });
    },
    submit() {
      this.msg = "";

      if (this.masterCustomer.id == this.slaveCustomer.id) {
        this.msg = "Cannot merge the same customer."
      } else {
        // Check for mollie
        const data = {
          query: `
            query { 
              Customer(id: ${this.slaveCustomer.id}) {
                mollie: mollie_payment_order_status
              }
            }
          `
        };

        this.simpleFetch({data, this_ref: this}).then((res) => {
          if (res.Customer.mollie != null
            && res.Customer.mollie == 'set_up') {
          this.msg = "Duplicate customer has mollie set up, cannot be merged automatically."
        } else {
          let data = {
            query: `
              mutation { 
                res: CustomerMerge (
                  master_customer_id: ${this.masterCustomer.id},
                  slave_customer_id: ${this.slaveCustomer.id},
                )
              }
            `
          };

          this.simpleMutation({ data, this_ref: this }).then(() => {
            this.fetchCustomers();
            this.masterCustomer = null;
            this.slaveCustomer = null;
          });
        }
        }).finally(()=>{
          //this.searching_imei = false;
        });
      }
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    if (!this.getUserBrandPermissions.super_admin) {
      this.$router.push({ name: "dashboard" });
    }
  },
  mounted() {
    this.fetchCustomers();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
